import React from 'react';
import { AppBar } from '@brighterion/br-ui';
import {
    shouldShowGlobalRules,
    shouldShowLists,
    shouldShowManageTenants,
    shouldShowMerchants,
    shouldShowRuleTests,
    shouldShowParameters,
    shouldShowReports,
    shouldShowRevisions,
    shouldShowSimulations
} from 'Selectors';

// make it a constant in case they want to move into some config based
export const TABS = (RoleService: RulesRoleService, landlordId?: string, tenantKey?: string) => [
    {
        displayName: 'Global Rules',
        route: '/global-rules',
        showFeature: shouldShowGlobalRules() && RoleService.hasDesignAccess
    },
    {
        displayName: 'Tenants',
        route: '/tenants',
        showFeature: shouldShowManageTenants(landlordId, tenantKey) && RoleService.hasAnyTenantRole
    },
    {
        displayName: 'Parameters',
        route: '/parameters',
        showFeature: shouldShowParameters() && RoleService.hasParameterAccess
    },
    {
        displayName: 'Merchants',
        route: '/overrides',
        subNavName: 'Manage Merchants',
        showFeature: shouldShowMerchants() && RoleService.hasDesignAccess
    },
    {
        displayName: 'Lists',
        route: '/list-management',
        // TODO: figure out how to restrict when we get roles
        showFeature: shouldShowLists() && RoleService.hasListOrDesignAccess
    },
    {
        displayName: 'Simulations',
        route: '/simulations',
        showFeature: shouldShowSimulations() && RoleService.hasDesignAccess
    },
    {
        displayName: 'Rule Tests',
        route: '/rule-tests',
        showFeature: shouldShowRuleTests()
    },
    {
        displayName: 'Reports',
        route: '/reports',
        showFeature: shouldShowReports() && RoleService.hasReportAccess
    },
    {
        displayName: 'Revisions',
        route: '/revisions',
        showFeature: shouldShowRevisions() && RoleService.hasDesignAccess
    }
];

const MenuTab = React.memo(
    ({
        route,
        displayName,
        isActive,
        onClick
    }: {
        route: string;
        displayName: string;
        isActive: boolean;
        onClick: () => void;
    }) => {
        return (
            <AppBar.MenuItem
                active={isActive}
                key={route}
                id={`navlink-${route}`}
                onClick={() => {
                    onClick();
                }}
            >
                {displayName}
            </AppBar.MenuItem>
        );
    }
);

export default MenuTab;
